var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6183 8.32645C23.3026 8.32645 23.0469 8.07061 23.0469 7.75502C23.0469 7.43943 23.3026 7.18359 23.6183 7.18359",
    stroke: "white",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6172 8.32645C23.9328 8.32645 24.1886 8.07061 24.1886 7.75502C24.1886 7.43943 23.9328 7.18359 23.6172 7.18359",
    stroke: "white",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M1.96094 7.84211C1.96094 4.59404 4.59402 1.96094 7.84211 1.96094H23.5253C26.7733 1.96094 29.4065 4.59404 29.4065 7.84211V23.5253C29.4065 26.7733 26.7733 29.4064 23.5253 29.4064H7.84211C4.59402 29.4064 1.96094 26.7733 1.96094 23.5253V7.84211Z",
    stroke: "white",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M15.684 21.5126C18.9031 21.5126 21.5126 18.9031 21.5126 15.684C21.5126 12.465 18.9031 9.85547 15.684 9.85547C12.465 9.85547 9.85547 12.465 9.85547 15.684C9.85547 18.9031 12.465 21.5126 15.684 21.5126Z",
    stroke: "white",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram-white.9af0ff837a610fe167644870bb056146.svg";
export { ForwardRef as ReactComponent };